import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {BonusAndCashBalanceBox} from "./boxes/bonus-and-cash-balance.box";
import {BalanceInnerBox} from "./boxes/balance-inner.box";
import {BalanceTitleInnerBox} from "./boxes/balance-title-inner.box";
import { BalanceValue } from "../balance-value.component";
import { BalanceValueBonusAndCashBox } from "../balance-value-boxes/balance-value-bonus-and-cash.box";
import { BalanceType } from "../../../../common/const/wallet_balance_type";
import {CyClass} from '../../../../common/cy-classes';

export class BonusAndCashBalance extends OrbitComponent {
  render() {
    const translator = this.services.translation;

    return (
      <BonusAndCashBalanceBox className={CyClass('cy-bonus-and-cash-balance')}>
        <BalanceInnerBox>
          <BalanceTitleInnerBox>{translator.translate('CASH_BALANCE')}</BalanceTitleInnerBox>
          <BalanceValue balanceType={BalanceType.CASH} WrapperComponent={BalanceValueBonusAndCashBox} className={CyClass('cy-cache-balance')} />
        </BalanceInnerBox>
        <BalanceInnerBox>
          <BalanceTitleInnerBox>{translator.translate('BONUS_BALANCE')}</BalanceTitleInnerBox>
          <BalanceValue balanceType={BalanceType.BONUS} WrapperComponent={BalanceValueBonusAndCashBox} className={CyClass('cy-bonus-balance')} />
        </BalanceInnerBox>
      </BonusAndCashBalanceBox>
    );
  }
}
